import { observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkButtonToggle, UitkButtonToggleGroup } from 'uitk-react-button-toggle';

import { FormFieldBinding } from './form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

const ButtonTracked = ClickTracker(UitkButtonToggle);

@FormFieldBinding
@observer
export class ButtonToggleGroupCheckbox extends React.Component<SearchFormFieldProps> {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(event) {
    const target = event.target;
    const { name, value } = target;
    const { updateModel, model, modelKey } = this.props;
    const oldValue = model && model[modelKey];
    let selectedPropertyClasses = [];

    if (oldValue && oldValue.length > 0) {
      if (typeof oldValue === 'string') {
        selectedPropertyClasses = oldValue && oldValue.split(',');
      } else {
        selectedPropertyClasses = oldValue;
      }
    }

    if (typeof updateModel === 'function') {
      updateModel({
        target: {
          name,
          value: this.getSelectorValue(selectedPropertyClasses, value)
        }
      });
    }
  }

  private getSelectorValue(selectedPropertyClasses: string[], value: string) {
    if (selectedPropertyClasses.includes(value)) {
      selectedPropertyClasses = selectedPropertyClasses.filter(item => item !== value);
    } else {
      selectedPropertyClasses = [...selectedPropertyClasses, value];
    }

    if (selectedPropertyClasses.length > 0) {
      return selectedPropertyClasses.join(',');
    }

    return '';
  }

  public render() {
    const { model, modelKey, sortAndFilterOptions } = this.props;
    const propertyClass = sortAndFilterOptions && sortAndFilterOptions[modelKey];
    const name = propertyClass && propertyClass.name;
    const options = propertyClass && propertyClass.options;
    const label = propertyClass && propertyClass.label;
    const subLabel = propertyClass && propertyClass.subLabel;
    const value = model && model[modelKey];

    if (!options || !options.length) {
      return null;
    }

    return (
      <fieldset className="all-b-margin-six">
        <legend className="uitk-type-heading-400 uitk-type-bold">
          {label}
          <span className="pwa-theme--grey-700 uitk-type-regular">{subLabel}</span>
        </legend>
        <div className="property-class-input uitk-flex">
          <React.Fragment>
            <UitkButtonToggleGroup>
              {options.map(
                (option, idx) =>
                  option && (
                    <ButtonTracked
                      key={`${name}-${idx}`}
                      id={`${name}-${idx}`}
                      name={name}
                      value={option.value}
                      aria-label={option.ariaLabel}
                      checked={value && value.includes(option.value)}
                      onChange={this.handleChange}
                      labelText={option.label}
                      rfrr={`${name}.${option.value}`}
                      linkName={`${label} - ${option.label}`}
                    />
                  )
              )}
            </UitkButtonToggleGroup>
          </React.Fragment>
        </div>
      </fieldset>
    );
  }
}
